import { GetStaticProps } from 'next';
import { PassengersPageId } from '../../features/app/pages/domain/constants/PageId';
import { createGetStaticPropsWithPage } from '../../features/app/root/domain/use-cases/createGetStaticPropsWithPage';
import { IFlightDetailsPageData } from '../../features/flights/detail/domain/models/IFlightDetailsPageData';
import { FlightDetailsPage } from '../../features/flights/detail/ui/FlightDetailPage';

import { getFlightsEnrichmentData } from '../../features/flights/shared/flight/domain/use-cases/getFlightsEnrichmentData';
import { defaultLocale as locale } from '../../features/shared/i18n/locale/constants/default';
import { getFlightDetailsHighlightImage } from '../../features/flights/detail/domain/use-cases/getFlightDetailsHighlightImage';
import { getStaticPathsForLocales } from '../../features/app/pages/domain/use-cases/getStaticPathsForLocales';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps: GetStaticProps<IFlightDetailsPageData> =
	createGetStaticPropsWithPage(PassengersPageId.FlightDetail, {
		flightsEnrichmentData: () => getFlightsEnrichmentData(locale),
		highlightImage: getFlightDetailsHighlightImage,
	});

export default FlightDetailsPage;
